import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../styles/Sidebar.css';
import {
  FaHome,
  FaBlog,
  FaFileAlt,
  FaSignOutAlt
} from 'react-icons/fa';

const BloggerSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    navigate('/login');
  };

  const isActive = (path) => {
    // Exact match for specific routes, prevent /blogger/blogs from matching /blogger/blogs/create
    if (path === '/blogger/blogs/create' || path === '/blogger/blogs/edit') {
      return location.pathname === path || location.pathname.startsWith(path + '/');
    }
    // For other routes, use exact match
    return location.pathname === path;
  };

  const menuItems = [
    {
      label: 'Dashboard',
      icon: <FaHome />,
      path: '/blogger/dashboard'
    },
    {
      label: 'Manage Blogs',
      icon: <FaBlog />,
      path: '/blogger/blogs'
    },
    {
      label: 'Create Blog',
      icon: <FaFileAlt />,
      path: '/blogger/blogs/create'
    }
  ];

  return (
    <div className="admin-sidebar">
      {/* Navigation Menu */}
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <button
            key={item.path}
            className={`nav-btn ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
            title={item.label}
          >
            <span className="nav-icon">{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      {/* Logout */}
      <div className="sidebar-footer">
        <button className="nav-btn logout-btn" onClick={handleLogout} title="Logout">
          <span className="nav-icon"><FaSignOutAlt /></span>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default BloggerSidebar;